<template>
  <!-- <SplashScreen v-if="$store.state.isLoading" /> -->
  <main class="w-full flex-grow p-6">
    <div class="flex justify-between">
      <h1 class="text-3xl text-black pb-6">Company</h1>
      <div class="mr-10">
        Web Status
        <div class="flex flex-row items-center h-9 mb-5 justify-between">
          <div class="relative cursor-pointer" @click="updateLive">
            <div
              class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
              :class="{ 'bg-app-default': is_live }"
            ></div>
            <div
              class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
              :class="{ 'translate-x-6': is_live }"
            ></div>
          </div>
          <div class="font-bold">
            {{ loading_is_live ? "Loading..." : is_live ? "ON" : "OFF" }}
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Logo (150 px X 150 px)</div>
            <div @click="togleModalUpdateLogo" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div v-if="company.company_logo !== undefined" class="flex">
            <img
              @click="showModal(company.company_logo)"
              class="w-32 h-32 mr-3 cursor-pointer"
              :src="company.company_logo"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Home Banner (1200 px X 500 px)</div>
            <div @click="togleModalUpdateBanner" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div
            v-if="company.company_banner !== undefined"
            class="flex flex-wrap"
          >
            <img
              v-for="(avt, index) in company.company_banner"
              :key="index"
              class="w-96 h-52 mr-3 mb-3 cursor-pointer"
              @click="showModal(avt)"
              :src="avt"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2 mb-10">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              About Header (600 px X 400 px)
            </div>
            <div @click="showModalBannerAbout" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              :src="aboutUsBanner.banner"
              @click="showModal(aboutUsBanner.banner)"
              alt="23paskal-about-us-banner"
              class="w-64 h-42 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              About Image (1170 px X 1080 px)
            </div>
            <div @click="togleModalUpdateBgSmall" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div
            v-if="company.company_background_small !== undefined"
            class="flex"
          >
            <img
              class="w-52 h-52 mr-3 cursor-pointer"
              @click="showModal(company.company_background_small)"
              :src="company.company_background_small"
              :alt="company.company_background_small"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap">
      <div class="w-full my-6 pr-0 lg:pr-2">
        <div class="leading-loose">
          <div class="p-5 bg-white rounded shadow-xl">
            <div class="flex justify-between border-b-2 mb-5 pb-5">
              <div class="font-bold text-2xl">Info</div>
              <div
                @click="togleModalUpdateCompanyInfo"
                class="mr-5 cursor-pointer"
              >
                <fas icon="pencil-alt" class="text-app-default text-2xl" />
              </div>
            </div>
            <div class="mb-5 font-bold">
              Name
              <div class="ml-8 font-normal">{{ company.company_name }}</div>
            </div>
            <div class="mb-5 font-bold">
              Domain
              <div class="ml-8 font-normal">{{ company.domain_name }}</div>
            </div>
            <div class="mb-5 font-bold">
              Telephone
              <div class="ml-8 font-normal">{{ company.company_phone }}</div>
            </div>
            <div class="mb-5 font-bold">
              Celuller
              <div class="ml-8 font-normal">{{ company.company_cellular }}</div>
            </div>
            <div class="mb-5 font-bold">
              Email
              <div class="ml-8 font-normal">{{ company.company_email }}</div>
            </div>
            <div class="mb-5 font-bold">
              Year Of Launching
              <div class="ml-8 font-normal">
                {{ company.year_of_launching }}
              </div>
            </div>
            <div class="mb-5 font-bold">
              daily open
              <div class="ml-8 font-normal">
                {{ company.company_daily_open }}
              </div>
            </div>
            <div class="mb-5 font-bold">
              daily close
              <div class="ml-8 font-normal">
                {{ company.company_daily_close }}
              </div>
            </div>
            <div class="mb-5 font-bold">
              holiday open
              <div class="ml-8 font-normal">
                {{ company.company_holiday_open }}
              </div>
            </div>
            <div class="mb-5 font-bold">
              holiday close
              <div class="ml-8 font-normal">
                {{ company.company_holiday_close }}
              </div>
            </div>
            <div class="mb-5 font-bold">
              Address
              <div class="ml-8 font-normal">{{ company.company_address }}</div>
            </div>
            <div class="mb-5 font-bold">
              Description
              <!-- <div class="ml-8 font-normal">
                {{ company.company_description }}
              </div> -->
              <div
                class="ml-8 font-normal"
                v-html="company.company_description"
              ></div>
            </div>
            <div class="mb-5 font-bold">
              Architect
              <div class="ml-8 font-normal">
                {{ company.company_architect }}
              </div>
            </div>
            <div class="mb-5 font-bold">
              Surface Area
              <div class="ml-8 font-normal">
                {{ company.company_surface_area }}
              </div>
            </div>
            <div class="mb-5 font-bold">
              Longitude
              <div class="ml-8 font-normal">{{ company.longitude }}</div>
            </div>
            <div class="mb-5 font-bold">
              Latitude
              <div class="ml-8 font-normal">{{ company.latitude }}</div>
            </div>
            <div class="mb-5 font-bold">
              Map Url
              <div class="ml-8 font-normal">{{ company.map_url }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Reference Logo</div>
            <div
              @click="togleModalUpdateReferenceLogo"
              class="mr-5 cursor-pointer"
            >
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div v-if="company.reference_logo !== undefined" class="flex">
            <img
              class="w-32 h-32 mr-3 cursor-pointer"
              @click="showModal(company.reference_logo)"
              :src="company.reference_logo"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div> -->

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Reference Images (1080px X 882 px)
            </div>
            <div
              @click="togleModalUpdatereferenceImage"
              class="mr-5 cursor-pointer"
            >
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div
            v-if="company.reference_images !== undefined"
            class="flex flex-wrap"
          >
            <img
              :key="index"
              class="w-52 h-52 mr-3 mb-3 cursor-pointer"
              @click="showModal(avt)"
              :src="company?.reference_images"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Reference</div>
            <div
              @click="togleModalUpdateReferenceInfo"
              class="mr-5 cursor-pointer"
            >
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="mb-5 font-bold">
            Reference From
            <div class="ml-8 font-normal">{{ company.reference_from }}</div>
          </div>
          <div class="mb-5 font-bold">
            Reference Description
            <!-- <div class="ml-8 font-normal">
              {{ company.reference_description }}
            </div> -->
            <div
              class="ml-8 font-normal"
              v-html="company.reference_description"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal update logo -->
    <div
      v-if="modalLogo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 350px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Logo (150 px X 150 px)
            </div>
            <div class="">
              <button
                @click.self="togleModalUpdateLogo"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.company_logo ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewLogoImage"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewLogoImage"
                  id="company_logo_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="logo.previewLogo"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeLogoFile"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="logo.previewLogo"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="logo.previewLogo === null"
                    v-cloak
                    @click="chooseLogoFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.company_logo_msg }}
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="togleModalUpdateLogo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateLogo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="togleModalUpdateLogo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal bg small -->
    <div
      v-if="modalBgSmall"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 350px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update About Image (1170 px X 1080 px)
            </div>
            <div class="">
              <button
                @click.self="togleModalUpdateBgSmall"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.background_small ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewBgSmallImage"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewBgSmallImage"
                  id="company_bg_small_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="bg.previewBgSmall"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeBgSmallFile"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="bg.previewBgSmall"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="bg.previewBgSmall === null"
                    v-cloak
                    @click="chooseBgSmallFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-sm text-red-600 mb-5">
              {{ errors.background_small_msg }}
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="togleModalUpdateBgSmall"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateBgSmall"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="togleModalUpdateBgSmall"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal banner -->
    <div
      v-if="modalBanner"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 500px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Update Banner (1200 px X 500 px)
            </div>
            <div class="">
              <button
                @click.self="togleModalUpdateBanner"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.company_banner ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewBannerImage"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewBannerImage"
                  id="company_banner_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row flex-wrap">
                  <div
                    v-for="(item, index) in banner.previewBanner"
                    :key="index"
                    class="mr-1 relative rounded-lg mb-2"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeBannerFile(index)"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img :src="item" class="w-full h-52 rounded-lg" />
                  </div>
                  <div
                    v-if="banner.previewBanner.length < 1"
                    v-cloak
                    @click="chooseBannerFile()"
                    class="w-full h-52 mr-1 mb-2 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-sm text-red-600 mb-5">
              {{ errors.company_banner_msg }}
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div
              class="flex"
              :class="[
                banner.previewBanner.length ? 'justify-between' : 'justify-end',
              ]"
            >
              <button
                v-if="banner.previewBanner.length"
                @click.self="prevTogleBanner"
                type="button"
                class="bg-green-500 border-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Preview
              </button>
              <div class="flex justify-end">
                <button
                  @click.self="togleModalUpdateBanner"
                  type="button"
                  class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
                >
                  Close
                </button>
                <button
                  @click.self="updateBanner"
                  type="button"
                  class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
                >
                  {{ saveButton }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="togleModalUpdateBanner"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Update info -->
    <div
      v-if="modalCompanyInfo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="togleModalUpdateCompanyInfo"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Edit Company Information
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Company Name</label
                >
                <input
                  v-model="update.company_name"
                  @keyup="companyNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.company_name_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Telephone</label
                >
                <input
                  v-model="update.company_phone"
                  @keyup="phoneChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_phone
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.company_phone_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Cellular</label
                >
                <input
                  v-model="update.company_cellular"
                  @keyup="cellularChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_cellular
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.company_cellular_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Email</label>
                <input
                  v-model="update.company_email"
                  @keyup="emailChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_email
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.company_email_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Year Launching</label
                >
                <input
                  v-model="update.year_of_launching"
                  @keyup="yearLaunchingChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.year_of_launching
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.year_of_launching_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Domain</label
                >
                <input
                  v-model="update.domain_name"
                  @keyup="domainNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.domain_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.domain_name_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Address</label
                >
                <textarea
                  v-model="update.company_address"
                  @keyup="descriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_address
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Address"
                >
                </textarea>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.company_address?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.company_address?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.company_address_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="update.company_description"
                  @keyup="descriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="update.company_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="descriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    update?.company_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ update?.company_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.company_description_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2 mb-5">
                <label class="font-semibold text-black opacity-80"
                  >Daily Open</label
                >
                <v-date-picker
                  timezone=""
                  v-model="update.company_daily_open"
                  mode="time"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2 mb-5">
                <label class="font-semibold text-black opacity-80"
                  >Daily Close</label
                >
                <v-date-picker
                  timezone=""
                  v-model="update.company_daily_close"
                  mode="time"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2 mb-5">
                <label class="font-semibold text-black opacity-80"
                  >Holiday Open</label
                >
                <v-date-picker
                  timezone=""
                  v-model="update.company_holiday_open"
                  mode="time"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2 mb-5">
                <label class="font-semibold text-black opacity-80"
                  >Holiday Close</label
                >
                <v-date-picker
                  timezone=""
                  v-model="update.company_holiday_close"
                  mode="time"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Architect</label
                >
                <input
                  v-model="update.company_architect"
                  @keyup="architectChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_architect
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.company_architect_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Surface Area</label
                >
                <input
                  v-model="update.company_surface_area"
                  @keyup="surfaceAreaChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.company_surface_area
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.company_surface_area_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Longitude</label
                >
                <input
                  v-model="update.longitude"
                  @keyup="longitudeChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.longitude
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.longitude_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Latitude</label
                >
                <input
                  v-model="update.latitude"
                  @keyup="latitudeChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.latitude
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.latitude_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Map Url</label
                >
                <input
                  v-model="update.map_url"
                  @keyup="mapUrlChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.map_url
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="ex: https://goo.gl/maps/1fURxEaBhrbi5ymb7"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.map_url_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="togleModalUpdateCompanyInfo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateCompanyInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="togleModalUpdateCompanyInfo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal Banner About -->
    <div
      v-if="modalBannerAbout"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 300px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalBannerAbout"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            About Header (600 px X 400 px)
          </div>
          <div class="p-6 flex-grow">
            <div
              class="border-dotted border-2 border-black p-2 rounded-lg"
              @drop="previewBannerAbout"
            >
              <input
                type="file"
                accept="image/*"
                @change="previewBannerAbout"
                id="bannerAbout"
                class="opacity-0 hidden"
              />
              <div class="flex flex-row">
                <div
                  v-if="update.previewBannerAbout"
                  class="mr-1 relative rounded-lg w-full"
                >
                  <button
                    class="absolute right-2 top-2"
                    type="button"
                    @click="removeBannerFileAbout"
                  >
                    <fas icon="trash-alt" class="text-red-600 text-3xl" />
                  </button>
                  <img
                    :src="update.previewBannerAbout"
                    class="w-full h-40 rounded-lg"
                  />
                </div>
                <div
                  v-if="update.previewBannerAbout === null"
                  v-cloak
                  @click="chooseBannerFileAbout()"
                  class="w-full h-40 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                >
                  <fas icon="image" class="text-gray-600 text-3xl" />
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalBannerAbout"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="!update.previewBannerAbout"
                @click="updateBannerAbout"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[
                  !update.previewBannerAbout ? 'bg-gray-500' : 'bg-blue-600',
                ]"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalBannerAbout"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal update Reference logo -->
    <div
      v-if="modalReferenceLogo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 350px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Update Reference Logo</div>
            <div class="">
              <button
                @click.self="togleModalUpdateReferenceLogo"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.reference_logo ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewReferenceLogoImage"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewReferenceLogoImage"
                  id="company_reference_logo_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="logo.previewReferenceLogo"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeReferenceLogoFile"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="logo.previewReferenceLogo"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="logo.previewReferenceLogo === null"
                    v-cloak
                    @click="chooseReferenceLogoFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-sm text-red-600 mb-5">
              {{ errors.reference_logo_msg }}
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="togleModalUpdateReferenceLogo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateReferenceLogo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="togleModalUpdateReferenceLogo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal update Reference image -->
    <div
      v-if="modalReferenceImage"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 350px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Reference Images (1080px X 882 px)
            </div>
            <div class="">
              <button
                @click.self="togleModalUpdatereferenceImage"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.reference_images ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewReferenceMultiple"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewReferenceMultiple"
                  id="reference_files"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="reference.previewReference[0]"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeReferencePreview"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="reference.previewReference[0]"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="!reference.previewReference.length"
                    v-cloak
                    @click="chooseReferenceFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-sm text-red-600 mb-5">
              {{ errors.reference_images_msg }}
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="togleModalUpdatereferenceImage"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateReferenceImages"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="togleModalUpdatereferenceImage"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal Reference content -->
    <div
      v-if="modalReferenceInfo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 700px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Edit Reference Info</div>
            <div class="">
              <button
                @click.self="togleModalUpdateReferenceInfo"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Reference From</label
                >
                <input
                  v-model="reference.reference_from"
                  @keyup="referenceFromChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.reference_from
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Reference From"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.reference_from_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Reference Description</label
                >
                <!-- <textarea
                  v-model="reference.reference_description"
                  @keyup="referenceDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.reference_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.reference_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="reference.reference_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="referenceDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    reference?.reference_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ reference?.reference_description?.length }} used out of
                  2000 characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.reference_description_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="togleModalUpdateReferenceInfo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="updateReferenceContent"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="togleModalUpdateReferenceInfo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- preview -->
    <div
      v-if="modalPrevBanner"
      class="z-50 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center bg-black"
    >
      <button
        @click="prevTogleBanner"
        class="absolute top-5 left-5 bg-white z-50 w-10 h-10 rounded-full flex items-center justify-center"
      >
        <fas icon="arrow-left" class="" />
      </button>
      <div class="z-50 relative mx-auto my-0 p-20">
        <div
          class="rounded shadow-lg border border-black flex flex-col overflow-hidden"
        >
          <splide :options="options">
            <splide-slide
              v-for="(item, index) in banner.previewBanner"
              :key="index"
            >
              <img :src="item" class="h-96 w-screen" />
            </splide-slide>
          </splide>
        </div>
      </div>
    </div>

    <Modal v-show="isModalVisible" @close="closeModal" :imageso="imageso" />
    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
import CKEditor from "../../components/CKEditor.vue";
// import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';
import "@splidejs/splide/dist/css/themes/splide-skyblue.min.css";
// import SplashScreen from '../../components/SplashScreen.vue'
import Modal from "../../components/Modal.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Dashboard",
  components: {
    Modal,
    Warning,
    SuccessNotif,
    CKEditor,
  },
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      imageso: "",
      isModalVisible: false,
      options: {
        rewind: true,
        width: 800,
        gap: "1rem",
      },
      companyId: null,
      company: {},
      modalLogo: false,
      modalBgSmall: false,
      modalReferenceLogo: false,
      modalBanner: false,
      modalReferenceImage: false,
      modalReferenceInfo: false,
      modalCompanyInfo: false,
      modalPrevBanner: false,
      aboutUsBanner: {},
      modalBannerAbout: false,
      errors: {
        company_logo: false,
        company_logo_msg: "",
        background_small: false,
        background_small_msg: "",
        company_banner: false,
        company_banner_msg: "",
        reference_logo: false,
        reference_logo_msg: "",
        reference_images: false,
        reference_images_msg: "",
        reference_from: false,
        reference_from_msg: "",
        reference_description: false,
        reference_description_msg: "",
        domain_name: false,
        company_name: false,
        year_of_launching: false,
        company_address: false,
        latitude: false,
        longitude: false,
        map_url: false,
        company_phone: false,
        company_cellular: false,
        company_description: false,
        company_surface_area: false,
        company_architect: false,
        company_email: false,
        is_live: false,
        domain_name_msg: "",
        company_name_msg: "",
        year_of_launching_msg: "",
        company_address_msg: "",
        latitude_msg: "",
        longitude_msg: "",
        map_url_msg: "",
        company_phone_msg: "",
        company_cellular_msg: "",
        company_description_msg: "",
        company_surface_area_msg: "",
        company_architect_msg: "",
        company_email_msg: "",
        is_live_msg: "",
      },
      bg: {
        previewBgSmall: null,
        bgSmallList: null,
      },
      banner: {
        previewBanner: [],
        imageBanner: [],
      },
      logo: {
        previewLogo: null,
        imageLogo: null,
        previewReferenceLogo: null,
        imageReferenceLogo: null,
      },
      is_live: null,
      loading_is_live: false,
      update: {
        previewBannerAbout: null,
        fileBannerAbout: null,
        company_name: "",
        domain_name: "",
        company_phone: "",
        company_cellular: "",
        company_email: "",
        year_of_launching: "",
        company_address: "",
        company_description: "",
        company_architect: "",
        company_surface_area: "",
        longitude: "",
        latitude: "",
        map_url: "",
        company_holiday_close: new Date(),
        company_holiday_open: new Date(),
        company_daily_close: new Date(),
        company_daily_open: new Date(),
      },
      reference: {
        previewReference: [],
        referenceList: [],
        reference_from: "",
        reference_description: "",
      },
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    showModalBannerAbout: function() {
      this.modalBannerAbout = !this.modalBannerAbout;
    },
    previewBannerAbout: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.update.previewBannerAbout = e.target.result;
        };
        this.update.fileBannerAbout = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeBannerFileAbout: function() {
      this.update.previewBannerAbout = null;
      this.update.fileBannerAbout = null;
    },
    chooseBannerFileAbout: function() {
      document.getElementById("bannerAbout").click();
    },
    updateBannerAbout: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("banner", this.update.fileBannerAbout);
      formdata.append("id", this.aboutUsBanner.id);
      try {
        let res = await fetch(`${API}v1/admin/company/update-about-banner`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.modalBannerAbout = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalBannerAbout = false;
        this.findAboutUsBanner();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalBannerAbout = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    findAboutUsBanner: async function() {
      try {
        let res = await fetch(`${API}v1/about_us_banner`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error(respon.message);
          return;
        }
        this.aboutUsBanner = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    prevTogleBanner: function() {
      this.modalPrevBanner = !this.modalPrevBanner;
    },
    closeTogleBanner: function() {
      this.modalPrevBanner = false;
    },
    companyNameChange: function(e) {
      this.reference.company_name = e.target.value;
      this.errors.company_name = false;
      this.errors.company_name_msg = "";
    },
    yearLaunchingChange: function(e) {
      this.reference.year_of_launching = e.target.value;
      this.errors.year_of_launching = false;
      this.errors.year_of_launching_msg = "";
    },
    domainNameChange: function(e) {
      this.reference.domain_name = e.target.value;
      this.errors.domain_name = false;
      this.errors.domain_name_msg = "";
    },
    addressChange: function(e) {
      this.reference.company_address = e.target.value;
      this.errors.company_address = false;
      this.errors.company_address_msg = "";
    },
    latitudeChange: function(e) {
      this.reference.latitude = e.target.value;
      this.errors.latitude = false;
      this.errors.latitude_msg = "";
    },
    longitudeChange: function(e) {
      this.reference.longitude = e.target.value;
      this.errors.longitude = false;
      this.errors.longitude_msg = "";
    },
    mapUrlChange: function(e) {
      this.reference.map_url = e.target.value;
      this.errors.map_url = false;
      this.errors.map_url_msg = "";
    },
    phoneChange: function(e) {
      this.reference.company_phone = e.target.value;
      this.errors.company_phone = false;
      this.errors.company_phone_msg = "";
    },
    cellularChange: function(e) {
      this.reference.company_cellular = e.target.value;
      this.errors.company_cellular = false;
      this.errors.company_cellular_msg = "";
    },
    descriptionChange: function() {
      // this.reference.company_description = e.target.value;
      this.errors.company_description = false;
      this.errors.company_description_msg = "";
    },
    surfaceAreaChange: function(e) {
      this.reference.company_surface_area = e.target.value;
      this.errors.company_surface_area = false;
      this.errors.company_surface_area_msg = "";
    },
    architectChange: function(e) {
      this.reference.company_architect = e.target.value;
      this.errors.company_architect = false;
      this.errors.company_architect_msg = "";
    },
    emailChange: function(e) {
      this.reference.company_email = e.target.value;
      this.errors.company_email = false;
      this.errors.company_email_msg = "";
    },
    referenceFromChange: function(e) {
      this.reference.reference_from = e.target.value;
      this.errors.reference_from = false;
      this.errors.reference_from_msg = "";
    },
    referenceDescriptionChange: function() {
      // this.reference.reference_description = e.target.value;
      this.errors.reference_description = false;
      this.errors.reference_description_msg = "";
    },
    togleModalUpdateLogo: function() {
      this.logo.previewLogo = null;
      this.logo.imageLogo = null;
      this.saveButton = "Save";
      this.modalLogo = !this.modalLogo;
    },
    togleModalUpdateBgSmall: function() {
      this.bg.previewBgSmall = null;
      this.bg.bgSmallList = null;
      this.saveButton = "Save";
      this.modalBgSmall = !this.modalBgSmall;
    },
    togleModalUpdateReferenceLogo: function() {
      this.logo.previewReferenceLogo = null;
      this.logo.imageReferenceLogo = null;
      this.saveButton = "Save";
      this.modalReferenceLogo = !this.modalReferenceLogo;
    },
    togleModalUpdateBanner: function() {
      this.banner.previewBanner = [];
      this.banner.imageBanner = [];
      this.saveButton = "Save";
      this.modalBanner = !this.modalBanner;
    },
    togleModalUpdatereferenceImage: function() {
      this.reference.previewReference = [];
      this.reference.referenceList = [];
      this.saveButton = "Save";
      this.modalReferenceImage = !this.modalReferenceImage;
    },
    togleModalUpdateReferenceInfo: function() {
      this.reference.reference_from = this.company.reference_from;
      this.reference.reference_description = this.company.reference_description;
      this.modalReferenceInfo = !this.modalReferenceInfo;
    },
    togleModalUpdateCompanyInfo: function() {
      this.update.company_name = this.company.company_name;
      this.update.domain_name = this.company.domain_name;
      this.update.company_phone = this.company.company_phone;
      this.update.company_cellular = this.company.company_cellular;
      this.update.company_email = this.company.company_email;
      this.update.year_of_launching = this.company.year_of_launching;
      this.update.company_address = this.company.company_address;
      this.update.company_description = this.company.company_description.replaceAll(
        "<br />",
        "\n"
      );
      this.update.company_architect = this.company.company_architect;
      this.update.company_surface_area = this.company.company_surface_area;
      this.update.longitude = this.company.longitude;
      this.update.latitude = this.company.latitude;
      this.update.map_url = this.company.map_url;
      this.update.company_daily_open = this.kelolaJam(
        this.company.company_daily_open
      );
      this.update.company_holiday_close = this.kelolaJam(
        this.company.company_holiday_close
      );
      this.update.company_daily_close = this.kelolaJam(
        this.company.company_daily_close
      );
      this.update.company_holiday_open = this.kelolaJam(
        this.company.company_holiday_open
      );
      this.modalCompanyInfo = !this.modalCompanyInfo;
    },
    chooseLogoFile: function() {
      document.getElementById("company_logo_file").click();
    },
    chooseBgSmallFile: function() {
      document.getElementById("company_bg_small_file").click();
    },
    chooseReferenceLogoFile: function() {
      document.getElementById("company_reference_logo_file").click();
    },
    chooseBannerFile: function() {
      document.getElementById("company_banner_file").click();
    },
    chooseReferenceFile: function() {
      document.getElementById("reference_files").click();
    },
    removeLogoFile: function() {
      this.logo.previewLogo = null;
      this.logo.imageLogo = null;
    },
    removeBgSmallFile: function() {
      this.bg.previewBgSmall = null;
      this.bg.bgSmallList = null;
    },
    removeReferenceLogoFile: function() {
      this.logo.previewReferenceLogo = null;
      this.logo.imageReferenceLogo = null;
    },
    removeBannerFile: function(i) {
      this.banner.previewBanner.splice(i, 1);
      this.banner.imageBanner.splice(i, 1);
    },
    removeReferencePreview() {
      this.reference.previewReference = [];
      this.reference.referenceList = [];
    },
    previewLogoImage: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.logo.previewLogo = e.target.result;
          // console.log(e.target.result);
        };
        this.logo.imageLogo = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.company_logo = false;
      this.errors.company_logo_msg = "";
    },
    previewBgSmallImage: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.bg.previewBgSmall = e.target.result;
        };
        this.bg.bgSmallList = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.background_small = false;
      this.errors.background_small_msg = "";
    },
    previewReferenceLogoImage: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.logo.previewReferenceLogo = e.target.result;
        };
        this.logo.imageReferenceLogo = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.reference_logo = false;
      this.errors.reference_logo_msg = "";
    },
    previewBannerImage: function(event) {
      let input = event.target;
      let count = input.files.length;
      let index = 0;
      if (input.files) {
        while (count--) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.banner.previewBanner.push(e.target.result);
          };
          this.banner.imageBanner.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      }
      this.errors.company_banner = false;
      this.errors.company_banner_msg = "";
    },
    previewReferenceMultiple: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.reference.previewReference.push(e.target.result);
        };
        this.reference.referenceList.push(input.files[0]);
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.reference_images = false;
      this.errors.reference_images_msg = "";
    },
    updateLogo: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("company_logo", this.logo.imageLogo);
      formdata.append("id", this.company.id);
      try {
        let res = await fetch(`${API}v1/admin/company/update-logo`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "company_logo") {
                this.errors.company_logo = true;
                this.errors.company_logo_msg = item.message;
              }
              if (item.key === "id") {
                this.errors.id = true;
                this.errors.id_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalLogo = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalLogo = false;
        this.saveButton = "Save";
        this._success("Data updated.");
        this.findCompany();
      } catch (err) {
        this.saveButton = "Save";
        this.modalLogo = false;
        this._error("internal server error");
      }
    },
    updateLive: async function() {
      this.loading_is_live = true;
      this.is_live = !this.is_live;
      let formdata = new FormData();
      formdata.append("is_live", this.is_live);
      formdata.append("id", this.company.id);
      try {
        let res = await fetch(`${API}v1/company/live`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "is_live") {
                this.errors.is_live = true;
                this.errors.is_live_msg = item.message;
              }
              if (item.key === "id") {
                this.errors.id = true;
                this.errors.id_msg = item.message;
              }
            });
            this.loading_is_live = false;
            this._error("Valdiation error");
            return;
          }
          this.loading_is_live = false;
          this._error(response.message);
          return;
        }
        this.loading_is_live = false;
        this._success("Website status updated.");
        this.findCompany();
      } catch (err) {
        this.loading_is_live = false;
        this._error("internal server error");
      }
    },
    updateBgSmall: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("background_small", this.bg.bgSmallList);
      formdata.append("id", this.company.id);
      try {
        let res = await fetch(`${API}v1/admin/company/update-background-small`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "background_small") {
                this.errors.background_small = true;
                this.errors.background_small_msg = item.message;
              }
              if (item.key === "id") {
                this.errors.id = true;
                this.errors.id_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalBgSmall = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalBgSmall = false;
        this.saveButton = "Save";
        this._success("Data updated.");
        this.findCompany();
      } catch (err) {
        this.saveButton = "Save";
        this.modalBgSmall = false;
        this._error("internal server error");
      }
    },
    // updateReferenceLogo: async function() {
    //   this.saveButton = "Loading...";
    //   let formdata = new FormData();
    //   formdata.append("reference_logo", this.logo.imageReferenceLogo);
    //   formdata.append("id", this.company.id);
    //   try {
    //     let res = await fetch(`${API}v1/company/reference/logo`, {
    //       method: "PUT",
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //       },
    //       body: formdata,
    //     });
    //     const response = await res.json();
    //     if (response.status !== 200) {
    //       if (response.message === "ERR_FORM") {
    //         response.data.map((item) => {
    //           if (item.key === "reference_logo") {
    //             this.errors.reference_logo = true;
    //             this.errors.reference_logo_msg = item.message;
    //           }
    //           if (item.key === "id") {
    //             this.errors.id = true;
    //             this.errors.id_msg = item.message;
    //           }
    //         });
    //         this.saveButton = "Save";
    //         return;
    //       }
    //       this.modalReferenceLogo = false;
    //       this.saveButton = "Save";
    //       this._error(response.message);
    //       return;
    //     }
    //     this.modalReferenceLogo = false;
    //     this.saveButton = "Save";
    //     this.findCompany();
    //   } catch (err) {
    //     this.saveButton = "Save";
    //     this.modalReferenceLogo = false;
    //     this._error("internal server error");
    //   }
    // },
    updateBanner: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      this.banner.imageBanner.map((itm) => {
        formdata.append("company_banner", itm);
      });
      formdata.append("id", this.company.id);
      try {
        let res = await fetch(`${API}v1/admin/company/update-company-banner`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "company_banner") {
                this.errors.company_banner = true;
                this.errors.company_banner_msg = item.message;
              }
              if (item.key === "id") {
                this.errors.id = true;
                this.errors.id_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }

          this.modalBanner = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalBanner = false;
        this.saveButton = "Save";
        this._success("Data updated.");
        this.findCompany();
      } catch (err) {
        this.saveButton = "Save";
        this.modalBanner = false;
        this._error("internal server error");
      }
    },
    updateReferenceImages: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("id", this.company.id);
      this.reference.referenceList.map((itm) => {
        formdata.append("reference_images", itm);
      });
      try {
        let res = await fetch(`${API}v1/admin/company/update-reference-image`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "reference_images") {
                this.errors.reference_images = true;
                this.errors.reference_images_msg = item.message;
              }
              if (item.key === "id") {
                this.errors.id = true;
                this.errors.id_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalReferenceImage = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalReferenceImage = false;
        this.saveButton = "Save";
        this._success("Data updated.");
        this.findCompany();
      } catch (err) {
        this.saveButton = "Save";
        this.modalReferenceImage = false;
        this._error("internal server error");
      }
    },
    updateReferenceContent: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/company/update-reference`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.company.id,
            reference_from: this.reference.reference_from,
            reference_description: this.reference.reference_description,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "reference_from") {
                this.errors.reference_from = true;
                this.errors.reference_from_msg = item.message;
              }
              if (item.key === "reference_description") {
                this.errors.reference_description = true;
                this.errors.reference_description_msg = item.message;
              }
              if (item.key === "id") {
                this.errors.id = true;
                this.errors.id_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalReferenceInfo = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalReferenceInfo = false;
        this.findCompany();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this.modalReferenceInfo = false;
        this._error("internal server error");
      }
    },
    getStringHours: function(val) {
      let stringHour = val.toString().split(" ")[4];
      // let arrHours = stringHour.split(":")
      return stringHour;
    },
    updateCompanyInfo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/company/update-info`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.company.id,
            company_name: this.update.company_name,
            domain_name: this.update.domain_name,
            company_phone: this.update.company_phone,
            company_cellular: this.update.company_cellular,
            company_email: this.update.company_email,
            year_of_launching: this.update.year_of_launching,
            company_address: this.update.company_address,
            company_description: this.update.company_description,
            company_architect: this.update.company_architect,
            company_surface_area: this.update.company_surface_area,
            longitude: this.update.longitude,
            latitude: this.update.latitude,
            map_url: this.update.map_url,
            company_holiday_close: this.getStringHours(
              this.update.company_holiday_close
            ),
            company_holiday_open: this.getStringHours(
              this.update.company_holiday_open
            ),
            company_daily_close: this.getStringHours(
              this.update.company_daily_close
            ),
            company_daily_open: this.getStringHours(
              this.update.company_daily_open
            ),
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "id") {
                this.errors.id = true;
                this.errors.id_msg = item.message;
              }
              if (item.key === "company_name") {
                this.errors.company_name = true;
                this.errors.company_name_msg = item.message;
              }
              if (item.key === "year_of_launching") {
                this.errors.year_of_launching = true;
                this.errors.year_of_launching_msg = item.message;
              }
              if (item.key === "company_address") {
                this.errors.company_address = true;
                this.errors.company_address_msg = item.message;
              }
              if (item.key === "latitude") {
                this.errors.latitude = true;
                this.errors.latitude_msg = item.message;
              }
              if (item.key === "longitude") {
                this.errors.longitude = true;
                this.errors.longitude_msg = item.message;
              }
              if (item.key === "map_url") {
                this.errors.map_url = true;
                this.errors.map_url_msg = item.message;
              }
              if (item.key === "company_phone") {
                this.errors.company_phone = true;
                this.errors.company_phone_msg = item.message;
              }
              if (item.key === "company_cellular") {
                this.errors.company_cellular = true;
                this.errors.company_cellular_msg = item.message;
              }
              if (item.key === "company_email") {
                this.errors.company_email = true;
                this.errors.company_email_msg = item.message;
              }
              if (item.key === "company_description") {
                this.errors.company_description = true;
                this.errors.company_description_msg = item.message;
              }
              if (item.key === "company_surface_area") {
                this.errors.company_surface_area = true;
                this.errors.company_surface_area_msg = item.message;
              }
              if (item.key === "company_architect") {
                this.errors.company_architect = true;
                this.errors.company_architect_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.modalCompanyInfo = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalCompanyInfo = false;
        this.findCompany();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this.modalCompanyInfo = false;
        this._error("internal server error");
      }
    },
    findCompany: async function() {
      try {
        let res = await fetch(`${API}v1/company`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this.company = respon.data;
          this._error("internal server error");
          return;
        }
        // console.log(respon.data.company_description);
        this.company = respon.data;
        this.is_live = respon.data.is_live;
        this.company.company_description = respon.data.company_description.replace(
          /(?:\r\n|\r|\n)/g,
          "<br />"
        );
      } catch (err) {
        this._error("internal server error");
      }
    },
    kelolaJam: function(jam) {
      let sekarang = new Date();
      let openDor = `${sekarang.getFullYear()}-${sekarang.getMonth() +
        1}-${sekarang.getDate()} ${jam}`;
      return new Date(openDor);
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findAboutUsBanner();
    this.findCompany();
  },
  beforeMount() {
    // console.log(this.$route.params.domain);
  },
};
</script>
